import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger mb-5"
}
const _hoisted_2 = {
  key: 1,
  class: "alert alert-warning mb-5"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" An active AI 24/7 location is required before enabling AI auto-reply. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Go to AI 24/7")
const _hoisted_5 = {
  key: 3,
  class: "seq-profile-form px-2 mt-5"
}
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, "Facebook comment to Messenger", -1)
const _hoisted_8 = { class: "form-check form-switch form-check-custom form-check-solid mb-0" }
const _hoisted_9 = {
  class: "form-check-label text-muted fs-7",
  for: "commentDmSectionToggle"
}
const _hoisted_10 = { class: "alert alert-light-info d-flex align-items-start mb-5" }
const _hoisted_11 = { class: "svg-icon svg-icon-2hx svg-icon-info me-4 mt-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "fs-7" }, [
  /*#__PURE__*/_createVNode("strong", null, "Comment-to-DM opener"),
  /*#__PURE__*/_createVNode("p", { class: "mb-0 mt-2" }, [
    /*#__PURE__*/_createTextVNode(" This message is sent as DM when someone comments on your Facebook post. For personalization, put "),
    /*#__PURE__*/_createVNode("code", null, "Hi {{contact.first_name}}! 👋"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_13 = { class: "seq-profile-row align-items-start mb-4" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label pt-2" }, "Messenger message", -1)
const _hoisted_15 = { class: "seq-profile-control" }
const _hoisted_16 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-3 mt-3" }
const _hoisted_17 = { class: "text-muted fs-8" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger fs-7 mt-2"
}
const _hoisted_19 = {
  key: 4,
  class: "seq-profile-form px-2 mt-5"
}
const _hoisted_20 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4" }
const _hoisted_21 = /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, "Facebook auto-comment replies", -1)
const _hoisted_22 = { class: "form-check form-switch form-check-custom form-check-solid mb-0" }
const _hoisted_23 = {
  class: "form-check-label text-muted fs-7",
  for: "autoCommentsSectionToggle"
}
const _hoisted_24 = { class: "alert alert-light-info d-flex align-items-start mb-5" }
const _hoisted_25 = { class: "svg-icon svg-icon-2hx svg-icon-info me-4 mt-1" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "fs-7" }, [
  /*#__PURE__*/_createVNode("strong", null, "Public comment replies"),
  /*#__PURE__*/_createVNode("p", { class: "mb-0 mt-2" }, " These messages are used when replying to Facebook comments. The workflow randomly picks one of the five replies below. ")
], -1)
const _hoisted_27 = { class: "seq-field-label seq-profile-label pt-2" }
const _hoisted_28 = { class: "seq-profile-control" }
const _hoisted_29 = { class: "text-muted fs-8 mt-2" }
const _hoisted_30 = { class: "d-flex flex-wrap align-items-center justify-content-end gap-3 mb-4" }
const _hoisted_31 = {
  key: 0,
  class: "text-danger fs-7 mb-4"
}
const _hoisted_32 = {
  key: 5,
  class: "seq-profile-form px-2 mt-5"
}
const _hoisted_33 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4" }
const _hoisted_34 = /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, "Checkout recovery emails", -1)
const _hoisted_35 = { class: "form-check form-switch form-check-custom form-check-solid mb-0" }
const _hoisted_36 = {
  class: "form-check-label text-muted fs-7",
  for: "checkoutRecoverySectionToggle"
}
const _hoisted_37 = { class: "alert alert-light-info d-flex align-items-start mb-5" }
const _hoisted_38 = { class: "svg-icon svg-icon-2hx svg-icon-info me-4 mt-1" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "fs-7" }, [
  /*#__PURE__*/_createVNode("strong", null, "Reminder after checkout starts"),
  /*#__PURE__*/_createVNode("p", { class: "mb-0 mt-2" }, " When someone fills out checkout but does not complete payment, a reminder email can be sent automatically from your AI 24/7 workspace. ")
], -1)
const _hoisted_40 = { class: "seq-profile-row align-items-center mb-4" }
const _hoisted_41 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Checkout recovery", -1)
const _hoisted_42 = { class: "seq-profile-control" }
const _hoisted_43 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_44 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label text-muted fs-7",
  for: "checkoutNurtureToggle"
}, " Send recovery emails for unpaid checkouts from this workspace. ", -1)
const _hoisted_45 = {
  key: 0,
  class: "text-danger fs-7 mb-4"
}
const _hoisted_46 = {
  key: 6,
  class: "seq-profile-form px-2"
}
const _hoisted_47 = { class: "seq-profile-row align-items-start mb-5" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label pt-2" }, "Default AI agent for auto-reply", -1)
const _hoisted_49 = { class: "seq-profile-control" }
const _hoisted_50 = /*#__PURE__*/_createVNode("option", { value: null }, "Select an AI agent…", -1)
const _hoisted_51 = { class: "form-text text-muted fs-7 mt-2" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" AI uses this agent when replying to Messenger DMs. Social accounts with their own agent override this default in Social Fan-out Settings. ")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Manage AI agents")
const _hoisted_54 = { class: "seq-profile-row align-items-center" }
const _hoisted_55 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Auto-reply to prospects", -1)
const _hoisted_56 = { class: "seq-profile-control" }
const _hoisted_57 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_58 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label text-muted fs-7",
  for: "aiAutoReplyToggle"
}, " When enabled, AI replies using your selected AI agent. ", -1)
const _hoisted_59 = {
  key: 0,
  class: "alert alert-warning mt-5 mb-0"
}
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "alert alert-light-primary mt-5 mb-0" }, " Replying manually in your AI 24/7 pauses AI for that conversation. You can resume AI from support flows when available. ", -1)
const _hoisted_61 = {
  key: 1,
  class: "card mt-5"
}
const _hoisted_62 = { class: "card-body" }
const _hoisted_63 = /*#__PURE__*/_createVNode("h5", { class: "card-title mb-2" }, "AI credits & usage (last 30 days)", -1)
const _hoisted_64 = {
  key: 0,
  class: "text-muted fs-7 mb-4"
}
const _hoisted_65 = { class: "mb-4" }
const _hoisted_66 = { class: "d-flex flex-wrap flex-stack gap-3 mb-2" }
const _hoisted_67 = { class: "text-muted fs-7" }
const _hoisted_68 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" AI Credit Top Up ")
const _hoisted_70 = {
  key: 1,
  class: "alert alert-warning mb-4"
}
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" AI auto-reply paused — insufficient AI credits. Use ")
const _hoisted_72 = /*#__PURE__*/_createVNode("strong", null, "AI Credit Top Up", -1)
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" above to add credits. ")
const _hoisted_74 = { class: "d-flex flex-wrap gap-5 mb-4" }
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-7" }, "Replies sent", -1)
const _hoisted_76 = { class: "fs-4 fw-bold" }
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-7" }, "Credits used (30 days)", -1)
const _hoisted_78 = { class: "fs-4 fw-bold" }
const _hoisted_79 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_80 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-3 mb-0" }
const _hoisted_81 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fs-7 fw-bold" }, [
    /*#__PURE__*/_createVNode("th", null, "Event"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Count"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Credits used")
  ])
], -1)
const _hoisted_82 = { class: "fs-7" }
const _hoisted_83 = { class: "text-end fs-7" }
const _hoisted_84 = { class: "text-end fs-7" }
const _hoisted_85 = {
  key: 3,
  class: "text-muted fs-7 mb-0"
}
const _hoisted_86 = {
  key: 2,
  class: "alert alert-light-warning mt-5 mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_AiDmOnboarding = _resolveComponent("AiDmOnboarding")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.loadError)
      ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.loadError), 1))
      : _createCommentVNode("", true),
    (!_ctx.hasGhlLocation)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_router_link, {
            to: "/settings/ai247-portal",
            class: "fw-bold"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasGhlLocation)
      ? (_openBlock(), _createBlock(_component_AiDmOnboarding, {
          key: 2,
          "integrations-url": _ctx.resolvedIntegrationsUrl,
          loading: _ctx.loading,
          completing: _ctx.completingOnboarding,
          resetting: _ctx.resettingOnboarding,
          completed: _ctx.dmOnboardingCompleted,
          onComplete: _ctx.completeOnboarding,
          onReset: _ctx.resetOnboarding
        }, null, 8, ["integrations-url", "loading", "completing", "resetting", "completed", "onComplete", "onReset"]))
      : _createCommentVNode("", true),
    (_ctx.hasGhlLocation)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _withDirectives(_createVNode("input", {
                id: "commentDmSectionToggle",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sectionVisibility.commentDm = $event)),
                class: "form-check-input",
                type: "checkbox",
                "aria-expanded": _ctx.sectionVisibility.commentDm,
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.persistSectionVisibility && _ctx.persistSectionVisibility(...args)))
              }, null, 40, ["aria-expanded"]), [
                [_vModelCheckbox, _ctx.sectionVisibility.commentDm]
              ]),
              _createVNode("label", _hoisted_9, _toDisplayString(_ctx.sectionVisibility.commentDm ? "Hide settings" : "Show settings"), 1)
            ])
          ]),
          _withDirectives(_createVNode("div", null, [
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
              ]),
              _hoisted_12
            ]),
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode("div", _hoisted_15, [
                _withDirectives(_createVNode("textarea", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.commentDmValue = $event)),
                  class: "form-control form-control-solid",
                  rows: "3",
                  disabled: _ctx.commentDmLoading || _ctx.commentDmSaving,
                  maxlength: _ctx.commentDmMaxLength,
                  placeholder: "Thanks for commenting — how can I help?"
                }, null, 8, ["disabled", "maxlength"]), [
                  [_vModelText, _ctx.commentDmValue]
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("span", _hoisted_17, _toDisplayString(_ctx.commentDmValue.length) + " / " + _toDisplayString(_ctx.commentDmMaxLength) + " characters ", 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-primary",
                    disabled: _ctx.commentDmLoading || _ctx.commentDmSaving || !_ctx.commentDmDirty,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveCommentDm && _ctx.saveCommentDm(...args)))
                  }, _toDisplayString(_ctx.commentDmSaving ? "Saving…" : "Save message"), 9, ["disabled"])
                ]),
                (_ctx.commentDmError)
                  ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(_ctx.commentDmError), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 512), [
            [_vShow, _ctx.sectionVisibility.commentDm]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasGhlLocation)
      ? (_openBlock(), _createBlock("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode("div", _hoisted_22, [
              _withDirectives(_createVNode("input", {
                id: "autoCommentsSectionToggle",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.sectionVisibility.autoComments = $event)),
                class: "form-check-input",
                type: "checkbox",
                "aria-expanded": _ctx.sectionVisibility.autoComments,
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.persistSectionVisibility && _ctx.persistSectionVisibility(...args)))
              }, null, 40, ["aria-expanded"]), [
                [_vModelCheckbox, _ctx.sectionVisibility.autoComments]
              ]),
              _createVNode("label", _hoisted_23, _toDisplayString(_ctx.sectionVisibility.autoComments ? "Hide settings" : "Show settings"), 1)
            ])
          ]),
          _withDirectives(_createVNode("div", null, [
            _createVNode("div", _hoisted_24, [
              _createVNode("span", _hoisted_25, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
              ]),
              _hoisted_26
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.autoCommentValues, (value, index) => {
              return (_openBlock(), _createBlock("div", {
                key: `auto-comment-${index}`,
                class: "seq-profile-row align-items-start mb-4"
              }, [
                _createVNode("label", _hoisted_27, "Reply " + _toDisplayString(index + 1), 1),
                _createVNode("div", _hoisted_28, [
                  _withDirectives(_createVNode("textarea", {
                    "onUpdate:modelValue": ($event: any) => (_ctx.autoCommentValues[index] = $event),
                    class: "form-control form-control-solid",
                    rows: "2",
                    disabled: _ctx.autoCommentLoading || _ctx.autoCommentSaving,
                    maxlength: _ctx.autoCommentMaxLength,
                    placeholder: `Auto-comment reply ${index + 1}`
                  }, null, 8, ["onUpdate:modelValue", "disabled", "maxlength", "placeholder"]), [
                    [_vModelText, _ctx.autoCommentValues[index]]
                  ]),
                  _createVNode("div", _hoisted_29, _toDisplayString(_ctx.autoCommentValues[index].length) + " / " + _toDisplayString(_ctx.autoCommentMaxLength) + " characters ", 1)
                ])
              ]))
            }), 128)),
            _createVNode("div", _hoisted_30, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary",
                disabled: _ctx.autoCommentLoading || _ctx.autoCommentSaving || !_ctx.autoCommentDirty,
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveAutoComments && _ctx.saveAutoComments(...args)))
              }, _toDisplayString(_ctx.autoCommentSaving ? "Saving…" : "Save replies"), 9, ["disabled"])
            ]),
            (_ctx.autoCommentError)
              ? (_openBlock(), _createBlock("div", _hoisted_31, _toDisplayString(_ctx.autoCommentError), 1))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.sectionVisibility.autoComments]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasGhlLocation)
      ? (_openBlock(), _createBlock("div", _hoisted_32, [
          _createVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode("div", _hoisted_35, [
              _withDirectives(_createVNode("input", {
                id: "checkoutRecoverySectionToggle",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.sectionVisibility.checkoutRecovery = $event)),
                class: "form-check-input",
                type: "checkbox",
                "aria-expanded": _ctx.sectionVisibility.checkoutRecovery,
                onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.persistSectionVisibility && _ctx.persistSectionVisibility(...args)))
              }, null, 40, ["aria-expanded"]), [
                [_vModelCheckbox, _ctx.sectionVisibility.checkoutRecovery]
              ]),
              _createVNode("label", _hoisted_36, _toDisplayString(_ctx.sectionVisibility.checkoutRecovery ? "Hide settings" : "Show settings"), 1)
            ])
          ]),
          _withDirectives(_createVNode("div", null, [
            _createVNode("div", _hoisted_37, [
              _createVNode("span", _hoisted_38, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
              ]),
              _hoisted_39
            ]),
            _createVNode("div", _hoisted_40, [
              _hoisted_41,
              _createVNode("div", _hoisted_42, [
                _createVNode("div", _hoisted_43, [
                  _withDirectives(_createVNode("input", {
                    id: "checkoutNurtureToggle",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.checkoutNurtureEnabled = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    disabled: _ctx.checkoutNurtureLoading || _ctx.checkoutNurtureSaving,
                    onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.saveCheckoutNurture && _ctx.saveCheckoutNurture(...args)))
                  }, null, 40, ["disabled"]), [
                    [_vModelCheckbox, _ctx.checkoutNurtureEnabled]
                  ]),
                  _hoisted_44
                ])
              ])
            ]),
            (_ctx.checkoutNurtureError)
              ? (_openBlock(), _createBlock("div", _hoisted_45, _toDisplayString(_ctx.checkoutNurtureError), 1))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.sectionVisibility.checkoutRecovery]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasGhlLocation && _ctx.dmOnboardingCompleted)
      ? (_openBlock(), _createBlock("div", _hoisted_46, [
          _createVNode("div", _hoisted_47, [
            _hoisted_48,
            _createVNode("div", _hoisted_49, [
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.defaultAgentId = $event)),
                class: "form-select form-select-solid",
                disabled: _ctx.saving || _ctx.loading,
                onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)))
              }, [
                _hoisted_50,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableAgents, (agent) => {
                  return (_openBlock(), _createBlock("option", {
                    key: agent.id,
                    value: agent.id
                  }, _toDisplayString(agent.name) + _toDisplayString(agent.knowledgeBaseName ? ` (${agent.knowledgeBaseName})` : ""), 9, ["value"]))
                }), 128))
              ], 40, ["disabled"]), [
                [_vModelSelect, _ctx.defaultAgentId]
              ]),
              _createVNode("div", _hoisted_51, [
                _hoisted_52,
                _createVNode(_component_router_link, {
                  to: "/settings/ai247-portal?tab=ai-agents",
                  class: "fw-bold"
                }, {
                  default: _withCtx(() => [
                    _hoisted_53
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_54, [
            _hoisted_55,
            _createVNode("div", _hoisted_56, [
              _createVNode("div", _hoisted_57, [
                _withDirectives(_createVNode("input", {
                  id: "aiAutoReplyToggle",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.aiEnabled = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  disabled: _ctx.saving || !_ctx.canEnableAi || !_ctx.defaultAgentId || _ctx.usageCredits.creditsDepleted,
                  onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)))
                }, null, 40, ["disabled"]), [
                  [_vModelCheckbox, _ctx.aiEnabled]
                ]),
                _hoisted_58
              ])
            ])
          ]),
          (!_ctx.globalAiEnabled)
            ? (_openBlock(), _createBlock("div", _hoisted_59, " AI auto-reply is not yet enabled for this environment. Your preference will be saved and applied when the feature is turned on. "))
            : _createCommentVNode("", true),
          _hoisted_60,
          (_ctx.usageLoaded)
            ? (_openBlock(), _createBlock("div", _hoisted_61, [
                _createVNode("div", _hoisted_62, [
                  _hoisted_63,
                  (_ctx.usagePeriodLabel)
                    ? (_openBlock(), _createBlock("div", _hoisted_64, _toDisplayString(_ctx.usagePeriodLabel), 1))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_65, [
                    _createVNode("div", _hoisted_66, [
                      _createVNode("span", _hoisted_67, " AI credits: " + _toDisplayString(_ctx.formatNumber(_ctx.usageCredits.displayCreditsRemaining)) + " remaining ", 1),
                      _createVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-primary",
                        disabled: _ctx.topUpLoading,
                        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.startCreditTopUp && _ctx.startCreditTopUp(...args)))
                      }, [
                        (_ctx.topUpLoading)
                          ? (_openBlock(), _createBlock("span", _hoisted_68))
                          : _createCommentVNode("", true),
                        _hoisted_69
                      ], 8, ["disabled"])
                    ])
                  ]),
                  (_ctx.usageCredits.creditsDepleted)
                    ? (_openBlock(), _createBlock("div", _hoisted_70, [
                        _hoisted_71,
                        _hoisted_72,
                        _hoisted_73
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_74, [
                    _createVNode("div", null, [
                      _hoisted_75,
                      _createVNode("div", _hoisted_76, _toDisplayString(_ctx.usageSummary.chatReplyCount), 1)
                    ]),
                    _createVNode("div", null, [
                      _hoisted_77,
                      _createVNode("div", _hoisted_78, _toDisplayString(_ctx.formatNumber(_ctx.usageCredits.displayCreditsUsedInPeriod)), 1)
                    ])
                  ]),
                  (_ctx.usageByEventType.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_79, [
                        _createVNode("table", _hoisted_80, [
                          _hoisted_81,
                          _createVNode("tbody", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.usageByEventType, (row) => {
                              return (_openBlock(), _createBlock("tr", {
                                key: row.eventType
                              }, [
                                _createVNode("td", _hoisted_82, _toDisplayString(_ctx.formatEventType(row.eventType)), 1),
                                _createVNode("td", _hoisted_83, _toDisplayString(_ctx.formatNumber(row.count)), 1),
                                _createVNode("td", _hoisted_84, _toDisplayString(_ctx.formatNumber(row.displayCreditsUsed)), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_85, "No AI usage recorded in the last 30 days yet."))
                ])
              ]))
            : (_ctx.usageError)
              ? (_openBlock(), _createBlock("div", _hoisted_86, _toDisplayString(_ctx.usageError), 1))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}